import { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Contact.css';

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.49 13a19.79 19.79 0 01-3-8.56A2 2 0 012.46 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 9.4a16 16 0 006.72 6.72l.77-.77a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);
const LocationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const LinkedinIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);
const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <path d="M16 11.37a4 4 0 11-2.63-3.74 4 4 0 012.63 3.74z"/>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
  </svg>
);
const GithubIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
  </svg>
);
const SendIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);

const CONTACT_EMAIL = 'talhakhaliddhariwal@gmail.com';

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', subject: 'Project Inquiry', message: '' });

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await fetch(`https://formsubmit.co/ajax/${CONTACT_EMAIL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          subject: form.subject,
          message: form.message,
          _template: 'table',
        }),
      });

      const result = await response.json();

      if (result.success) {
        setSent(true);
        setForm({ name: '', email: '', subject: 'Project Inquiry', message: '' });
        setTimeout(() => setSent(false), 4000);
      } else {
        alert('Failed to send message. Please try again.');
      }
    } catch (error) {
      alert('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page page-enter">
      <Navbar />

      {/* HEADER */}
      <section className="ct-header">
        <div className="ct-container">
          <span className="ct-badge">Get in Touch</span>
          <h1>Let's build something<br /><span className="purple">remarkable</span> together.</h1>
          <p>Whether you have a project in mind, want to collaborate, or just want to say hello — my inbox is always open.</p>
        </div>
      </section>

      {/* MAIN */}
      <section className="ct-main">
        <div className="ct-container">
          <div className="ct-grid">
            {/* LEFT */}
            <div className="ct-left">
              <div className="ct-info-cards">
                {[
                  { icon: <MailIcon />, label: 'Email', value: CONTACT_EMAIL, href: `mailto:${CONTACT_EMAIL}` },
                  { icon: <PhoneIcon />, label: 'Phone', value: '+923036810903', href: 'tel:+923036810903' },
                  { icon: <LocationIcon />, label: 'Location', value: 'Sialkot, Pakistan', href: null },
                ].map(item => (
                  <div key={item.label} className="ct-info-card">
                    <div className="ct-info-icon">{item.icon}</div>
                    <div>
                      <p className="ct-info-label">{item.label}</p>
                      {item.href
                        ? <a href={item.href} className="ct-info-value">{item.value}</a>
                        : <p className="ct-info-value">{item.value}</p>
                      }
                    </div>
                  </div>
                ))}
              </div>

              <p className="ct-social-heading">Find me on</p>
              <div className="ct-socials">
                {[
                  { icon: <LinkedinIcon />, label: 'LinkedIn', href: 'https://www.linkedin.com/in/talha-khalid-81ba97266/' },
                  { icon: <InstagramIcon />, label: 'Instagram', href: 'https://www.instagram.com/talha_._khalid' },
                  { icon: <GithubIcon />, label: 'GitHub', href: 'https://github.com/Talha-Khalid-D' },
                ].map(s => (
                  <a key={s.label} href={s.href} target="_blank" rel="noreferrer" className="ct-social">
                    {s.icon}
                    <span>{s.label}</span>
                  </a>
                ))}
              </div>

              <div className="ct-availability">
                <span className="ct-dot" />
                <p>Currently available for new projects</p>
              </div>
            </div>

            {/* FORM */}
            <div className="ct-form-wrap">
              <h3>Send a Message</h3>
              <p>Fill out the form and I'll get back to you within 24 hours.</p>
              <form className="ct-form" onSubmit={handleSubmit} noValidate>
                <div className="ct-form-row">
                  <div className="ct-form-group">
                    <label>Name</label>
                    <input
                      type="text" name="name" required
                      placeholder="Talha Khalid"
                      value={form.name} onChange={handleChange}
                    />
                  </div>
                  <div className="ct-form-group">
                    <label>Email</label>
                    <input
                      type="email" name="email" required
                      placeholder="talhakhalid@example.com"
                      value={form.email} onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="ct-form-group">
                  <label>Subject</label>
                  <select name="subject" value={form.subject} onChange={handleChange}>
                    <option>Project Inquiry</option>
                    <option>Collaboration</option>
                    <option>Consulting</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className="ct-form-group">
                  <label>Message</label>
                  <textarea
                    name="message" required rows={6}
                    placeholder="Tell me about your project..."
                    value={form.message} onChange={handleChange}
                  />
                </div>
                <button type="submit" className="btn-primary ct-send-btn" disabled={loading}>
                  {loading ? 'Sending...' : sent ? '✓ Message Sent!' : <><SendIcon /> Send Message</>}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
